import AuthService from './auth-service';
import { Roles, UserRole } from './user.model';
import { SnackbarType } from 'components/Snackbar/SnackbarProvider';
import { useAppDispatch } from 'store';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { useSnackbar } from 'components/Snackbar';
import {
  AuthActions,
  selectLoggedUser,
  selectUserRoles,
} from 'store/modules/auth';

export function useTokenVerification() {
  const appDispatch = useAppDispatch();
  const user = useSelector(selectLoggedUser);
  const { show } = useSnackbar();

  return useQuery(['tokenVerification', user], AuthService.validateToken, {
    onSettled: (data) => {
      if (data !== 'Valid Token') {
        appDispatch(AuthActions.logout());
        show({
          type: SnackbarType.error,
          message: 'Token inválido, se ha cerrado la sesión',
          autoHide: true,
        });
      }
    },
    enabled: user,
    refetchInterval: false,
  });
}

export function useGetSellerRole(requiredRoles: Roles[]): Roles {
  const userRoles: UserRole[] = useSelector(selectUserRoles);
  let sellerRole = Roles.FIJASTH_PY_VENTAS;

  userRoles
    .map((role) => role.name)
    .forEach((userRole) => {
      requiredRoles.forEach((requiredRole) => {
        if (userRole === requiredRole) {
          sellerRole = requiredRole;
        }
      });
    });

  return sellerRole;
}

export function useUserRole(requiredRoles: Roles[], strict = false) {
  const userRoles: UserRole[] = useSelector(selectUserRoles);
  const user = useSelector(selectLoggedUser);
  const test = (role) => userRoles.map((r) => r.name).includes(role);
  let isAuthorized = false;

  if (!user) {
    return false;
  }

  if (strict) {
    isAuthorized = requiredRoles.every(test);
  } else {
    isAuthorized = requiredRoles.some(test);
  }

  return isAuthorized;
}

export function useGetMetadata() {
  const { data } = useQuery(
    [`config-metadata`],
    () => AuthService.getMetadata(),
    {
      retry: false,
      refetchOnWindowFocus: false,
      cacheTime: 0,
    }
  );

  return {
    isTieredBonusFlagEnabled: data?.isTieredBonusFlagEnabled,
    showTieredBonusSectionFlag: data?.showTieredBonusSectionFlag,
  };
}
